/**
 * Densité d'affichage — confortable / compacte, persistée.
 *
 * Calqué sur `theme.ts` : le choix explicite pose `data-density="compact"` sur <html>
 * (consommé par tokens.css, qui y resserre les espacements partagés `--space-*` et les
 * cartes shadcn `[data-slot="card"]`) ; « confortable » retire l'attribut. Le choix est
 * persisté pour survivre au rechargement.
 */
export type Density = 'comfortable' | 'compact'

const KEY = 'doit.density'

export function getDensity(): Density {
  try {
    if (localStorage.getItem(KEY) === 'compact') return 'compact'
  } catch {
    /* stockage indisponible : on retombe sur « confortable » */
  }
  return 'comfortable'
}

export function applyDensity(density: Density): void {
  const root = document.documentElement
  if (density === 'compact') root.setAttribute('data-density', 'compact')
  else root.removeAttribute('data-density')
}

export function setDensity(density: Density): void {
  try {
    if (density === 'compact') localStorage.setItem(KEY, 'compact')
    else localStorage.removeItem(KEY)
  } catch {
    /* ignore : la densité s'appliquera quand même pour la session courante */
  }
  applyDensity(density)
}

/** Applique la densité stockée au démarrage, avant le premier rendu (évite le flash). */
export function initDensity(): void {
  applyDensity(getDensity())
}
